module.exports = __webpack_public_path__ + "static/media/img-4.4de8c30e.jpg";